import App from './App.vue';
import router from './router';
import { setupStore } from '/@/store';
import ElementPlus from 'element-plus';
import { getServerConfig } from './config';

import { createApp, Directive } from 'vue';
// import { useI18n } from "../src/plugins/i18n";
import { MotionPlugin } from '@vueuse/motion';
import { createResponsiveStorageInjector } from '@klondpay/utils';
import { routerArrays } from '/@/layout/types';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import { convertTime, convertSubmitTime } from './utils/commonTimeZone';

import 'animate.css';
// 引入 Tailwind CSS（必须先加载）
import '@klondpay/styles/tailwind.css';
// 引入公共样式库
import '@klondpay/styles';
// 导入项目特定样式
import './style/index.scss';
import 'element-plus/dist/index.css';
// 导入字体图标
import './assets/iconfont/iconfont.js';
import './assets/iconfont/iconfont.css';

// 全局注册`@iconify/vue`图标库
import { IconifyIconOffline, IconifyIconOnline, FontIcon } from '@klondpay/ui';
import { setupI18n } from './locales';

const app = createApp(App);

// 创建响应式存储注入函数
const injectResponsiveStorage = createResponsiveStorageInjector(routerArrays);

// Sentry.init({
//   app,
//   dsn: "http://691ddb954b044fe1bcceb7a2569f12c4@cqdev.paxpay.cn:9000/8",
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ["localhost", "my-site-url.com", /^\//]
//     })
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0
// });

// 自定义指令
import * as directives from '/@/directives';
Object.keys(directives).forEach((key) => {
  app.directive(key, (directives as { [key: string]: Directive })[key]);
});

app.component('IconifyIconOffline', IconifyIconOffline);
app.component('IconifyIconOnline', IconifyIconOnline);
app.component('FontIcon', FontIcon);

getServerConfig(app).then(async (config) => {
  // 国际化 i18n 配置
  await setupI18n(app);

  app.use(router);
  await router.isReady();
  injectResponsiveStorage(app, config);
  setupStore(app);

  app.use(MotionPlugin).use(ElementPlus);
  app.mount('#app');
});

app.config.globalProperties.$convertTime = convertTime;
app.config.globalProperties.$convertSubmitTime = convertSubmitTime;
